import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, Divider, Typography, MenuItem, Popover, useMediaQuery, CircularProgress } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { CustomAvatar } from '../../../reusable-components/custom-avatar';
import { useSelector } from '../../../redux/store';
import { clearUser } from '../../../redux/slices/user';
import { fullReload } from '../../../utils/fullReload';
import SiteSwitch from './SiteSwitch';
import { ScopeGuard } from '../../../reusable-components/scopes';
import axios from '../../../utils/axiosCacheCheck';

// ----------------------------------------------------------------------

export default function AccountPopover() {

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const islg = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const mobileStyles = {
    width: 28, 
    height: 28,
    fontSize: '12px'
  }
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const { firstName, lastName, email, id } = user;
  const [open, setOpen] = useState(null);
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = () => {
    setLoggingOut(true);
    axios.get(`Api/Logout`)
      .then(() => {
        setOpen(null);
        sessionStorage.removeItem('hasSeenLoginModal');
        setTimeout(() => {
          window.location.href = `/auth/login`;
          dispatch(clearUser());
        }, 50);
      })
      .catch(() => enqueueSnackbar("Logout has encountered an error", { variant: "error" }))
      .finally(() => setLoggingOut(false));
  };

  return (
    <>
      <CustomAvatar
        name={`${firstName} ${lastName}`}
        email={email}
        showTooltip={false}         
        onClick={(event) => setOpen(event.target)}
        sx={{
          cursor: 'pointer !important',
          ...(isMobile ? mobileStyles : {})
        }}
      />

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={() => setOpen(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { mt: 1.5, ml: islg ? 4 : 0 } }}
      >
        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          onClick={() => {
            navigate(`/dashboard/home/user/${id}?tab=user-information`);
            setOpen(null);
          }}
          sx={{ mt: 1 }}
        >
          <Box>
            <Typography variant="subtitle2" noWrap>
              {firstName} {lastName}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
              {email}
            </Typography>
          </Box>
        </MenuItem>      
        <Divider sx={{ borderStyle: 'dashed' }} />
        {isMobile && <ScopeGuard scopes={['Super-Admin']}>
          <MenuItem>
            <SiteSwitch />
          </MenuItem>
        </ScopeGuard>}
        <MenuItem onClick={fullReload} sx={{ m: 1 }}>
          Refresh
        </MenuItem>
        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Logout {loggingOut && <Box ml={1} alignContent="center" display="flex"><CircularProgress size={20} /></Box>}
        </MenuItem>
      </Popover>
    </>
  );
}
